/**
 * Tiny on-screen debug log. On a device we can't easily read logcat, so during native sign-in
 * bring-up we surface each stage on screen. Toggle with localStorage `lapo-debug` = "1" (set by
 * default here while we stabilize Android auth). Remove once sign-in is solid.
 */
export function debugEnabled(): boolean {
  try {
    // Opt-in: set localStorage `lapo-debug` = "1" to re-enable the on-screen trace.
    return localStorage.getItem('lapo-debug') === '1';
  } catch {
    return false;
  }
}

export function dbg(msg: string): void {
  if (!debugEnabled()) return;
  try {
    let el = document.getElementById('lapo-dbg');
    if (!el) {
      el = document.createElement('div');
      el.id = 'lapo-dbg';
      el.style.cssText =
        'position:fixed;top:0;left:0;right:0;z-index:2147483647;background:rgba(0,0,0,0.88);' +
        'color:#3f6;font:11px/1.35 monospace;padding:6px;max-height:45vh;overflow:auto;' +
        'white-space:pre-wrap;word-break:break-all;';
      const clear = document.createElement('button');
      clear.textContent = '✕';
      clear.style.cssText = 'position:absolute;top:2px;right:4px;color:#fff;background:transparent;border:0;font:14px monospace;';
      clear.onclick = () => el!.remove();
      el.appendChild(clear);
      document.body.appendChild(el);
    }
    const line = document.createElement('div');
    const t = new Date();
    const hh = String(t.getHours()).padStart(2, '0');
    const mm = String(t.getMinutes()).padStart(2, '0');
    const ss = String(t.getSeconds()).padStart(2, '0');
    line.textContent = `[${hh}:${mm}:${ss}] ${msg}`;
    el.appendChild(line);
    el.scrollTop = el.scrollHeight;
  } catch {
    /* never let logging break the flow */
  }
}
